import Vue from 'vue'
import Router from 'vue-router'
import App from '@/App'

import Home from '@/pages/Home' // 网站首页
import Error from '@/pages/Error' // 网站错误页 404

// 直播相关
import LiveIndex from '@/pages/live/Index' // 直播首页
import HotView from '@/pages/live/HotView' // 看点首页
import LiveDetail from '@/pages/live/LiveDetail' // 直播详情页
import LiveInteraction from '@/pages/live/Interaction' // 直播互动主页
import LiveInteractionPublish from '@/pages/live/InteractionPublish' // 直播互动主页
import FaceRecogPage from '@/pages/live/FaceRecogPage' //人脸识别功能页面
// import LiveInteractionDetail from '@/pages/live/InteractionDetail' // 直播互动详情页
// 用户相关
import UserIndex from '@/pages/user/Index' // 用户个人主页
import UserLogin from '@/components/Login/Login' // 登录授权
import UserDetail from '@/pages/user/UserDetail' // 用户登录授权个人主页
import UserInteraction from '@/pages/user/Interaction' // 用户个人互动主页
import UserInteractionDetail from '@/pages/user/InteractionDetail' // 用户互动详情
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      // 网站首页 yun.aiyaopai.com
      path: '/',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        next(false)
        window.location.href = 'https://yun.aiyaopai.com/static/home/index.html'
      },
      meta: {
        requireAuth: false
      }
    },
    {
      // 网站错误页 404
      path: '/error',
      name: 'error',
      component: Error,
      meta: {
        requireAuth: false
      }
    },
    {
      // 直播首页 yun.aiyaopai.com/live
      path: '/live',
      name: 'liveIndex',
      component: LiveIndex,
      beforeEnter: (to, from, next) => {
        next(false)
        window.location.href = 'https://yun.aiyaopai.com/static/home/index.html'
      },
      meta: {
        requireAuth: false
      }
    },
    {
      // 指定直播页面 yun.aiyaopai.com/live/20170618rzq
      path: '/live/:liveId',
      name: 'liveDetail',
      component: LiveDetail,
      meta: {
        requireAuth: false
      }
    },
    {
      // 指定直播对应互动列表 yun.aiyaopai.com/live/20170618rzq/interaction
      path: '/live/:liveId/interaction',
      name: 'liveInteraction',
      component: LiveInteraction,
      meta: {
        requireAuth: true
      }
    },
    {
      // 指定直播对应热门看点 yun.aiyaopai.com/live/20170618rzq/hotview
      path: '/live/:liveId/hotview',
      name: 'hotView',
      component: HotView,
      meta: {
        requireAuth: false
      }
    },
    {
      // 指定直播对应互动列表 yun.aiyaopai.com/live/20170618rzq/faceRecog
      path: '/live/:liveId/faceRecog',
      name: 'FaceRecogPage',
      component: FaceRecogPage,
      meta: {
        requireAuth: false
      }
    },
    {
      // 指定直播对应互动列表 yun.aiyaopai.com/live/20170618rzq/interaction
      path: '/live/:liveId/interaction/publish',
      name: 'liveInteractionPublish',
      component: LiveInteractionPublish,
      meta: {
        requireAuth: true
      }
    },
    {
      // 用户登录 yun.aiyaopai.com/login
      path: '/login',
      name: 'userLogin',
      component: UserLogin,
      meta: {
        requireAuth: false
      }
    },
    {
      // 互动主页 yun.aiyaopai.com/user
      path: '/live/:liveId/user',
      name: 'userIndex',
      component: UserIndex,
      meta: {
        requireAuth: true
      }
    },
    {
      // 互动主页 yun.aiyaopai.com/user
      path: '/live/:liveId/user/:interactionId',
      name: 'userInteractionDetail',
      component: UserInteractionDetail,
      meta: {
        requireAuth: true
      }
    }
    /**
    , {
      // 用户个人主页 yun.aiyaopai.com/user/9399382
      path: '/live/:liveId/user/:userId',
      name: 'userDetail',
      component: UserDetail
    }, {
      // 用户个人主页互动列表 yun.aiyaopai.com/user/9399382/interaction
      path: '/user/:userId/interaction',
      name: 'userInteraction',
      component: UserInteraction
    }, {
      // 用户个人主页互动详情 yun.aiyaopai.com/user/9399382/interaction/2929200
      path: '/user/:userId/interaction/:interactionId',
      name: 'userInteractionDetail',
      component: UserInteractionDetail
    }
     */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js